// Admin-facing option lists for the condition operators implemented by
// `conditionMatches` in conditionalFieldLabel.js. They live next to the matcher
// on purpose: every admin screen that authors a condition (Form Groups showIf /
// labelWhen, Detail Groups conditional label) reads from here, so adding an
// operator to the matcher and forgetting to offer it — or offering one the
// matcher does not implement — cannot happen silently.
export const CONDITION_OPERATORS = [
  { label: 'Equals (=)', value: 'eq' },
  { label: 'Not equals (≠)', value: 'neq' },
  { label: 'Has any value', value: 'truthy' },
  { label: 'Is empty', value: 'falsy' },
  { label: 'Is one of (comma-separated)', value: 'in' },
  { label: 'Is not one of (comma-separated)', value: 'notIn' },
  { label: 'Has at least one row (addRow group)', value: 'notEmpty' },
];

// Operators that carry a comparison value; the rest are unary, so the admin
// screens hide the Value input for them and the save path drops any stale one.
export const CONDITION_VALUE_OPERATORS = ['eq', 'neq', 'in', 'notIn'];

export const operatorNeedsValue = (operator) => CONDITION_VALUE_OPERATORS.includes(operator ?? 'eq');
